type ISnackbarType = "success" | "error" | "info" | "warning";

type IReducerActions = {
  type: ReducerActionType;
  payload?: Partial<IReducerState>;
};

interface IReducerState {
  snackbar: Partial<ISnackbar>;
  globalAlertDialog: Partial<IGlobalAlertDialog>;
}

interface ISnackbar {
  text: string;
  isOpen: boolean;
  type: ISnackbarType;
  duration?: number;
  handleClose: () => void;
}

interface IGlobalAlertDialog {
  isOpen: boolean;
  title: string;
  content: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  handleCancel?: () => void;
  handleConfirm?: () => void;
}

enum ReducerActionType {
  showSnackbar = "showSnackbar",
  hideSnackbar = "hideSnackbar",
  showGlobalAlertDialog = "showGlobalAlertDialog",
  hideGlobalAlertDialog = "hideGlobalAlertDialog",
}

interface IContextProps {
  state: IReducerState;
  dispatch: React.Dispatch<IReducerActions>;
}

export { ReducerActionType };

export type {
  IContextProps,
  IGlobalAlertDialog,
  IReducerActions,
  IReducerState,
  ISnackbar,
  ISnackbarType,
};
